// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"f2c37d20","551":"d9e72300"}[chunkId] + ".chunk.js";
};